var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "distribute-detail" },
    [
      _vm.$route.meta
        ? _c("div", { staticClass: "header" }, [
            _vm._v(_vm._s(_vm.$route.meta.title)),
          ])
        : _vm._e(),
      Object.keys(_vm.tableForm).length
        ? _c("Detail", {
            ref: "getDetail",
            attrs: {
              tableData: _vm.tableForm,
              tableFormAttrs: _vm.tableFormAttrs,
              formLabelWidth: "100px",
              filterDataRules: _vm.filterDataRules,
              merchantLogo: _vm.tableForm.merchantLogo,
            },
            on: {
              submitForm: _vm.submitForm,
              handleAvatarSuccess: _vm.handleAvatarSuccess,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (button) {
                    return [
                      _vm.isEdit
                        ? [
                            _c("el-button", { on: { click: _vm.cancel } }, [
                              _vm._v("取消"),
                            ]),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.submitFormDetail()
                                  },
                                },
                              },
                              [_vm._v("保存")]
                            ),
                          ]
                        : [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit()
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                          ],
                    ]
                  },
                },
              ],
              null,
              false,
              3358315537
            ),
          })
        : _vm._e(),
      +_vm.type !== 4
        ? _c(
            "div",
            { staticClass: "shop-list" },
            [
              _c(
                "Search",
                _vm._g(
                  _vm._b({}, "Search", _vm.filterAttrs, false),
                  _vm.filterEvent
                )
              ),
              _vm.listQueryParams.total > 0
                ? _c(
                    "div",
                    { staticClass: "store-export-all" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.handleSelectAllForExport },
                          model: {
                            value: _vm.selectAllForExport,
                            callback: function ($$v) {
                              _vm.selectAllForExport = $$v
                            },
                            expression: "selectAllForExport",
                          },
                        },
                        [
                          _vm._v(
                            " 勾选全部导出（共 " +
                              _vm._s(_vm.listQueryParams.total) +
                              " 家） "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "Table",
                _vm._g(
                  _vm._b(
                    {
                      ref: "storeTable",
                      attrs: { "list-query-params": _vm.listQueryParams },
                      on: {
                        "update:listQueryParams": function ($event) {
                          _vm.listQueryParams = $event
                        },
                        "update:list-query-params": function ($event) {
                          _vm.listQueryParams = $event
                        },
                      },
                    },
                    "Table",
                    _vm.tableAttrs,
                    false
                  ),
                  _vm.tableEvent
                )
              ),
              _vm.dialogFormVisible
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: _vm.title,
                        visible: _vm.dialogFormVisible,
                        width: "572px",
                        top: "3vh",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.dialogFormVisible = $event
                        },
                      },
                    },
                    [
                      _c("Detail", {
                        ref: "getTable",
                        attrs: {
                          title: _vm.title,
                          styleType: _vm.styleType,
                          tableData: _vm.dialogForm,
                          tableFormAttrs: _vm.dialogFormAttrs,
                          formLabelWidth: "91px",
                          isEdit: _vm.title === "编辑门店",
                        },
                        on: {
                          resetSecret: _vm.resetSecret,
                          handleAreaChange: _vm.handleAreaChange,
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer",
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.dialogFormVisible = false
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.sureButtonsName))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "批量导入门店",
                    visible: _vm.importDialogVisible,
                    width: "720px",
                    top: "5vh",
                    "close-on-click-modal": !_vm.importing,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.importDialogVisible = $event
                    },
                    closed: _vm.resetImportDialog,
                  },
                },
                [
                  _c("el-alert", {
                    staticClass: "import-alert",
                    attrs: {
                      type: "info",
                      closable: false,
                      "show-icon": "",
                      title: "Excel 格式要求（与 20260130.xlsx 一致）",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "import-format" },
                    [
                      _c("p", [_vm._v("请使用固定表头，从第 2 行开始填写：")]),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%", margin: "8px 0 12px" },
                          attrs: {
                            data: _vm.importFormatPreview,
                            border: "",
                            size: "mini",
                          },
                        },
                        _vm._l(_vm.IMPORT_HEADERS, function (col) {
                          return _c("el-table-column", {
                            key: col,
                            attrs: {
                              prop: col,
                              label: col,
                              "min-width": "100",
                            },
                          })
                        }),
                        1
                      ),
                      _c("ul", { staticClass: "import-tips" }, [
                        _c("li", [
                          _vm._v("列顺序不可调整，表头文字必须完全一致。"),
                        ]),
                        _c("li", [
                          _vm._v(
                            "省市区写成完整文字，例如：广东省珠海市斗门区。"
                          ),
                        ]),
                        _c("li", [
                          _vm._v("详细地址只填街道门牌，不要再重复写省市区。"),
                        ]),
                        _c("li", [
                          _vm._v(
                            "手机号必须唯一；系统已存在的手机会创建失败。"
                          ),
                        ]),
                        _c("li", [
                          _vm._v(
                            "初始密码可为空；所属商户自动使用当前商户，无需在表中填写。"
                          ),
                        ]),
                        _c("li", [_vm._v("邮箱默认为空，状态默认启用。")]),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-download" },
                          on: { click: _vm.downloadImportTemplate },
                        },
                        [_vm._v(" 下载导入模板 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-upload",
                    {
                      ref: "importUpload",
                      attrs: {
                        action: "",
                        "auto-upload": false,
                        "show-file-list": true,
                        limit: 1,
                        accept: ".xlsx,.xls",
                        "on-change": _vm.handleImportFileChange,
                        "on-remove": _vm.handleImportFileRemove,
                        "file-list": _vm.importFileList,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            disabled: _vm.importing,
                          },
                        },
                        [_vm._v(" 选择 Excel 文件 ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v("仅支持 .xlsx / .xls")]
                      ),
                    ],
                    1
                  ),
                  _vm.importRows.length
                    ? _c("div", { staticClass: "import-summary" }, [
                        _vm._v(" 已解析 "),
                        _c("b", [_vm._v(_vm._s(_vm.importRows.length))]),
                        _vm._v(" 条门店数据，确认后将逐条创建。 "),
                      ])
                    : _vm._e(),
                  _vm.importing || _vm.importResult.total
                    ? _c(
                        "div",
                        { staticClass: "import-progress" },
                        [
                          _c("el-progress", {
                            attrs: {
                              percentage: _vm.importProgress,
                              status: _vm.importProgressStatus,
                            },
                          }),
                          _c("div", { staticClass: "import-progress__text" }, [
                            _vm._v(
                              " 进度：" +
                                _vm._s(_vm.importResult.done) +
                                " / " +
                                _vm._s(_vm.importResult.total) +
                                " （成功 " +
                                _vm._s(_vm.importResult.success) +
                                "，失败 " +
                                _vm._s(_vm.importResult.fail) +
                                "） "
                            ),
                          ]),
                          _vm.importResult.failList.length
                            ? _c(
                                "el-table",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "margin-top": "10px",
                                  },
                                  attrs: {
                                    data: _vm.importResult.failList,
                                    border: "",
                                    size: "mini",
                                    "max-height": "220",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "row",
                                      label: "行号",
                                      width: "70",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "storeName",
                                      label: "门店名称",
                                      "min-width": "140",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "phone",
                                      label: "手机号",
                                      width: "120",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "msg",
                                      label: "失败原因",
                                      "min-width": "180",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: _vm.importing },
                          on: {
                            click: function ($event) {
                              _vm.importDialogVisible = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.importResult.done &&
                                  _vm.importResult.done >=
                                    _vm.importResult.total
                                  ? "关闭"
                                  : "取消"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.importing,
                            disabled: !_vm.importRows.length || _vm.importing,
                          },
                          on: { click: _vm.startImportStores },
                        },
                        [_vm._v(" 开始导入 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }